import { Avatar, AvatarFallback, AvatarImage } from '@talentmesh/ui/components/avatar';
import { TypographyH2, TypographyP } from '@talentmesh/ui/components/typography';
import { EmploymentTypes, Salary, WorkArrangements, formatSalary } from '@talentmesh/utils';
import React, { Fragment } from 'react';
import { isMobile } from 'react-device-detect';
import DotSeparator from '../components/DotSeparator';
import UIStrings from '../utils/UIStrings';
import { employmentTypeToUIString, workArrangementToString } from '../utils/UIStringsFormattings';

interface HeaderProps {
    companyIconUrl?: string;
    title: string;
    companyName: string;
    location: string;
    workArrangement: WorkArrangements;
    employmentType: EmploymentTypes;
    salary?: Salary;
}

function Header({
    companyIconUrl,
    title,
    companyName,
    location,
    workArrangement,
    employmentType,
    salary,
}: HeaderProps): React.JSX.Element {
    const items = [
        companyName,
        `${location} (${workArrangementToString(workArrangement)})`,
        employmentTypeToUIString(employmentType),
        formatSalary(salary, UIStrings.Yearly),
    ].filter(Boolean);

    return (
        <div className="flex flex-row gap-2">
            {!isMobile && companyIconUrl && (
                <Avatar className="size-18 rounded-full">
                    <AvatarImage src={companyIconUrl} alt={companyName} />
                    <AvatarFallback>{companyName.charAt(0)}</AvatarFallback>
                </Avatar>
            )}
            <div className="flex flex-col gap-2">
                <TypographyH2>{title}</TypographyH2>
                <div className={`flex flex-row flex-wrap items-start gap-y-2 ${isMobile ? 'gap-x-1' : 'gap-x-4'}`}>
                    {items.map((item, index) => (
                        <Fragment key={item}>
                            {index > 0 && <DotSeparator />}
                            <TypographyP className="text-base">{item}</TypographyP>
                        </Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Header;
